/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M480 0c17.597 0 32 14.405 32 32v448c0 17.592-14.402 32-32 32H32c-17.593 0-32-14.408-32-32V32C0 14.405 14.407 0 32 0zM256.423 94.5c-93.508 0-169.635 61.779-169.635 137.635 0 68.017 60.35 125.064 141.864 135.84 5.524 1.159 13.036 3.63 14.929 8.362 1.68 4.287 1.1 11.046.52 15.333 0 0-1.95 11.935-2.413 14.523-.773 4.287-3.418 16.743 14.677 9.154 18.172-7.648 97.737-57.569 133.367-98.51 24.584-26.94 36.345-54.324 36.345-84.702 0-75.914-76.069-137.635-169.654-137.635zm-100.074 97.602c4.944 0 8.903 4.017 8.903 8.883v58.535h24.777a8.868 8.868 0 018.903 8.902c0 4.867-3.96 8.884-8.903 8.884h-33.68a8.86 8.86 0 01-8.883-8.884v-67.437c0-4.866 3.958-8.883 8.883-8.883zm204.242 0c4.866 0 8.883 4.017 8.883 8.883a8.864 8.864 0 01-8.883 8.903h-24.796v15.894h24.796c4.866 0 8.883 3.959 8.883 8.883 0 4.867-3.959 8.903-8.883 8.903h-24.796v15.894h24.796c4.866 0 8.883 3.959 8.883 8.902 0 4.925-4.017 8.884-8.883 8.884h-33.757c-4.867 0-8.884-3.96-8.884-8.884v-67.379c0-4.866 4.017-8.883 8.884-8.883h33.757zm-63.478 0c4.944 0 8.903 4.017 8.903 8.883v67.38c0 3.823-2.472 7.26-6.103 8.42-.908.328-1.892.463-2.8.463-2.781 0-5.446-1.294-7.126-3.573l-34.53-47.043v41.655a8.864 8.864 0 01-8.883 8.903 8.868 8.868 0 01-8.903-8.903v-67.302c0-3.823 2.472-7.203 6.103-8.439a8.751 8.751 0 012.8-.444c2.78 0 5.446 1.294 7.126 3.573l34.53 47.043v-41.733c0-4.866 4.016-8.883 8.883-8.883zm-81.11 0c4.867 0 8.884 4.017 8.884 8.883v67.38a8.86 8.86 0 01-8.884 8.883 8.864 8.864 0 01-8.903-8.884v-67.379c0-4.866 3.96-8.883 8.903-8.883z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconLine = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconLine.defaultProps = {
  theme,
};
IconLine.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconLine.displayName = 'IconLine';
export { IconLine };
